import React, { useEffect, useState } from "react";
import Aos from "aos";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Social = () => {
  const data = useSelector((state) => state.main.data?.mainData?.[0]);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section className="social">
        <div className="background">
          <img src="/images/BGg.png" alt="" />
        </div>
        <div className="section">
          <div
            className="head-title"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <span>الموقع، تواصل</span>
          </div>
          <div className="section-container">
            <div className="right">
              <div
                className="anthor-title"
                data-aos="fade-left"
                data-aos-duration="1000"
                data-aos-delay="300"
              >
                <div className="title">
                  <span>موقع العيـــادة</span>
                </div>
                <div className="info">
                  بيت لحم، السينما، عمارة فريج الطابق الثاني، مقابل شركة
                  الكهرباء
                </div>
              </div>
              <div className="location">
                <img src="/images/location.png" alt="" />
                {/* <div
                  className="city"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="300"
                >
                  <div className="group">
                    {" "}
                    <div className="num">
                      <span>1</span>
                    </div>{" "}
                    <div className="icon">
                      <lord-icon
                        src="https://cdn.lordicon.com/fsvddbfp.json"
                        trigger="hover"
                        colors="primary:#413634"
                        target=".group"
                        style={{ width: "100%", height: "100%" }}
                      ></lord-icon>
                    </div>
                    <div className="title">بيـت لحـــم</div>
                  </div>
                </div>
                <div
                  className="cinema"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="600"
                >
                  <div className="group">
                    {" "}
                    <div className="num">
                      <span>2</span>
                    </div>
                    <div className="icon">
                      <lord-icon
                        src="https://cdn.lordicon.com/knfwjlul.json"
                        trigger="hover"
                        colors="primary:#413634"
                        target=".group"
                        style={{ width: "100%", height: "100%" }}
                      ></lord-icon>
                    </div>
                    <div className="title">السينـــما</div>
                  </div>{" "}
                </div>
                <div
                  className="tower"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="900"
                >
                  <div className="group">
                    <div className="num">
                      <span>3</span>
                    </div>
                    <div className="icon">
                      <lord-icon
                        src="https://cdn.lordicon.com/ntultglr.json"
                        trigger="hover"
                        colors="primary:#413634"
                        target=".group"
                        style={{ width: "100%", height: "100%" }}
                      ></lord-icon>
                    </div>
                    <div className="grouping">
                      <div className="group-title">عمـــارة فريـــج</div>
                      <div className="group-desc">الطـابـــق الثـانــي</div>
                      <div className="group-info">مقابـل شركة الكهرباء</div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="left">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3394.270270179803!2d35.20223518484478!3d31.708511381307723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDQyJzMwLjYiTiAzNcKwMTInMDAuMiJF!5e0!3m2!1sar!2seg!4v1712497405762!5m2!1sar!2seg"
                width="600"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
                data-aos="zoom-in"
                data-aos-duration="1000"
              ></iframe>

              <div
                className="info"
                data-aos="fade-in"
                data-aos-duration="1000"
                data-aos-delay="500"
              >
                <div className="icon">
                  <lord-icon
                    src="https://cdn.lordicon.com/tdtlrbly.json"
                    trigger="hover"
                    colors="primary:#413634,secondary:#413634"
                    target=".info"
                    style={{ width: "100%", height: "100%" }}
                  ></lord-icon>
                </div>
                <Link
                  to="https://maps.app.goo.gl/LRLwyYs3zDN1z1dz7"
                  className="title"
                >
                  موقع العيادة
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="section spic">
          <div
            className="simple-title"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            <span>تواصل معــنا</span>
          </div>

          <div className="container">
            <Link
              to="tel:+022749887"
              className="contact"
              data-aos="fade-down"
              data-aos-duration="1000"
            >
              <div className="icon">
                {" "}
                <lord-icon
                  src="https://cdn.lordicon.com/srsgifqc.json"
                  trigger="morph"
                  state="morph-phone-hang-up"
                  colors="primary:#413634,secondary:#413634"
                  target=".contact"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>{" "}
              </div>
              <div className="title">العياده</div>
              <div className="value">{data?.landline}</div>
            </Link>
            <Link
              to="tel:+972599041233"
              className="contact"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-delay="300"
            >
              <div className="icon">
                {" "}
                <lord-icon
                  src="https://cdn.lordicon.com/srsgifqc.json"
                  trigger="hover"
                  colors="primary:#413634,secondary:#413634"
                  target=".contact"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>
              </div>
              <div className="title">هاتف جوال</div>
              <div className="value">{data?.phone}</div>
            </Link>
            <Link
              to="https://wa.me/972599041233"
              className="contact"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-delay="600"
            >
              <div className="icon">
                {" "}
                <lord-icon
                  src="https://cdn.lordicon.com/ayhtotha.json"
                  trigger="hover"
                  colors="primary:#413634,secondary:#413634"
                  target=".contact"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>
              </div>
              <div className="title">واتساب</div>
              <div className="value">{data?.whatsapp}</div>
            </Link>
            <Link
              to="https://www.facebook.com/profile.php?id=100054236510520&mibextid=JRoKGi"
              className="contact"
              data-aos="fade-down"
              data-aos-duration="1000"
              data-aos-delay="900"
            >
              <div className="icon">
                {" "}
                <lord-icon
                  src="https://cdn.lordicon.com/cbigqefp.json"
                  trigger="hover"
                  colors="primary:#413634,secondary:#413634"
                  target=".contact"
                  style={{ width: "100%", height: "100%" }}
                ></lord-icon>
              </div>
              <div className="title">فيسبوك</div>
              <div className="value">{data?.facebook}</div>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Social;
